import { useFeatureFlags } from '@findigs/helpers/src/integrations/posthog/use-feature-flags';
import type { AvatarProps } from '@findigs/ui-kit/src/components/avatar';
import { Avatar } from '@findigs/ui-kit/src/components/avatar';
import { Button } from '@findigs/ui-kit/src/components/button';
import { Link as RemixLink } from '@remix-run/react';
import { styles } from './navbar-profile-card.module.scss';

export type NavbarProfileCardProps = Omit<AvatarProps, 'variant'> & {
  email: string;
  onLinkClicked?: () => void;
};

export const NavbarProfileCard = ({
  firstName,
  lastName,
  email,
  className,
  onLinkClicked,
  ...props
}: NavbarProfileCardProps) => {
  const featureFlags = useFeatureFlags();
  const classes = [styles, className].filter((c) => c).join(' ');
  const manageProfileProps = featureFlags?.new_profile_page
    ? ({ as: RemixLink, to: '/profile' } as const)
    : ({ as: 'a', href: '/update-profile' } as const);
  return (
    <div {...props} className={classes}>
      <div className="main">
        <Avatar
          className="avatar"
          firstName={firstName}
          lastName={lastName}
          variant="Person"
        />
        <div>
          <p>
            {firstName} {lastName}
          </p>
          <p className="email text-b-sm-regular">{email}</p>
        </div>
      </div>
      <div className="buttons">
        <Button
          variant="Outlined"
          {...manageProfileProps}
          onClick={onLinkClicked}
        >
          Manage profile
        </Button>
        <Button
          variant="Text"
          as={RemixLink}
          to="/logout"
          onClick={onLinkClicked}
        >
          Log out
        </Button>
      </div>
    </div>
  );
};
